(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/track/telephone/telephoneImportDialog.tpl.html',
    '<div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title" translate="telephonesList.telephoneImport.dialogTitle"></h3></div><div class="modal-body"><div><input onchange="angular.element(this).scope().fileChanged(this)" id="importFileBrowserBtn" type="file" accept="text/plain" ng-disabled="isFileinputDisabled"></div></div><div style="padding: 15px;"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="import()" translate="telephonesList.telephoneImport.importBtn" ng-disabled="isImportBtnDisabled"></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="close()" translate="deleteConfirm.cancel_button"></button></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephoneImportDialog.tpl.js